import { useMutation } from "@tanstack/react-query";

import { lookupCep } from "@/adapters/api";

// useCepLookup wraps the CEP proxy as an imperative mutation. Forms trigger it
// when the zipcode reaches 8 digits and autofill on success; a "not found"
// error is handled gracefully by the caller (manual entry stays available).
export function useCepLookup() {
	return useMutation({
		mutationFn: (cep: string) => lookupCep(cep),
	});
}
